export interface ISoccerJLeagueCupState {
  isShow: boolean;
  games?: Array<{
    url: string;
    teamHome: string;
    teamVisitor: string;
  }>;
}
const initialState: ISoccerJLeagueCupState = {
  isShow: false
};
export default (state: ISoccerJLeagueCupState = initialState) => {
  return state;
};
